import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getCustomersApi } from '../../api/endpoints';

// Initial state
const initialState = {
  status: '', // loading, success, error
  data: null,
  message: '',
};

// Async thunks for CREATE operations
export const getCustomerList = createAsyncThunk('getCustomerList', async (payload) => {
  return await getCustomersApi(payload);
});

const getCustomerListSlice = createSlice({
  name: 'getCustomerList', // Unique Name
  initialState,
  reducers: {
    getCustomerListReset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCustomerList.pending, (state) => {
        state.status = 'loading';
        state.data = {};
      })
      .addCase(getCustomerList.fulfilled, (state, action) => {
        const { message = '', data = [], payload = null } = action.payload;
        state.status = 'success';
        state.message = message;
        state.data = data || payload;
      })
      .addCase(getCustomerList.rejected, (state, action) => {
        const { message } = action.error || {};
        state.status = 'error';
        state.message = message;
      });
  },
});
export const { getCustomerListReset } = getCustomerListSlice.actions;

export default getCustomerListSlice.reducer;
